export default __webpack_public_path__ + "static/1default-f520b2de1b19f7e4f42f04be035800f2.png";